import { Controller } from "@hotwired/stimulus"
import { dispatchOpenContentWindow, windowRegistry } from "../vue/composables/useWindowRegistry"
import { shouldOpenInContentWindow } from "../vue/utils/content_window_link"

export default class extends Controller {
  connect() {
    this.onClick = this.onClick.bind(this)
    document.addEventListener("click", this.onClick, true)
  }

  disconnect() {
    document.removeEventListener("click", this.onClick, true)
  }

  onClick(event) {
    if (!shouldOpenInContentWindow(event)) return

    const link = event.target.closest("[data-content-window-id]")
    if (!link) return

    const id = link.dataset.contentWindowId
    if (!id) return

    event.preventDefault()
    event.stopPropagation()

    const detail = {
      id,
      title: link.dataset.contentWindowTitle || link.textContent.trim(),
      url: link.getAttribute("href") || link.dataset.contentWindowUrl,
    }

    windowRegistry.openWindow(detail)
    dispatchOpenContentWindow(detail)
  }

  open(event) {
    const { windowId, windowTitle, windowUrl } = event.params
    if (!windowId) return

    event.preventDefault()
    dispatchOpenContentWindow({
      id: windowId,
      title: windowTitle,
      url: windowUrl,
    })
  }
}
